import { LocalDictionaryFactory } from '../../api/api.module'

import { LoggerService } from '../../common/common.module'

import { IUserSession } from '../../../helpers/user-session'

import { ActorDetailsDirectiveController } from './actors-details.directive.controller'

import { ActorHelper } from '../actors.helper'
import { GRID_SERVICE_NAME, GridService } from '../../../services/grid';

//#region Asset Imports

import * as TEMPLATE from './actors-details.tpl.html'

//#endregion

// Consts

const TEMPLATE_PATH: string = `./${ActorHelper.FILE_NAME_PREFIX}-details.tpl.html`

// Consts End


// Setup

export class ActorDetailsDirective implements ng.IDirective {

    restrict = 'E'

    scope = {
        id: '='
    }

    controller = ['$scope', '$q', '$timeout', 'logger', 'localDictionary', 'userSession', GRID_SERVICE_NAME, (
        $scope: any,
        $q: ng.IQService,
        $timeout: ng.ITimeoutService,
        logger: LoggerService,
        localDictionary: LocalDictionaryFactory,
        userSession: IUserSession,
        gridService: GridService
    ) => new ActorDetailsDirectiveController(
        $scope,
        $q,
        $timeout,
        logger,
        localDictionary,
        userSession,
        gridService,
        ActorHelper.REFERENCE_TYPE,
        ActorHelper.SIMAX_MODULE_NAME
    )]

    template = TEMPLATE
}

// Setup End